import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c0107086")

_pushScopeId("data-v-c0107086")
const _hoisted_1 = { class: "nav-container flexbox-row justify-space-between padding-bottom-20 padding-top-20" }
const _hoisted_2 = { class: "title color-white barlow" }
_popScopeId()

import { useStore } from "@/store/store";
import { computed } from "vue";
import UsersList from "@/components/users-list/UsersList.vue";
import { useI18n } from "vue-i18n";


export default _defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();

/* COMPUTED */
const membActive = computed(function (): boolean {
  return store.getters.getMyClub.membership_attiva;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_unref(t)('users')), 1)
    ]),
    _createVNode(UsersList, {
      "mask-users-data": !_unref(membActive)
    }, null, 8, ["mask-users-data"])
  ], 64))
}
}

})